export default __webpack_public_path__ + "static/media/logo-white.45097170.svg";